const activeStudentCalendarsByCourse = (
  state = {
    isFetching: false,
    receivedAt: null,
    data: [],
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_ACTIVE_STUDENT_CALENDARS':
      return {
        ...state,
        isFetching: true,
      }
    case 'RECEIVE_ACTIVE_STUDENT_CALENDARS':
      return {
        ...state,
        isFetching: false,
        receivedAt: Date.now(),
        data: action.activeStudentCalendars,
      }
    default:
      return state
  }
}

const activeStudentCalendars = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        ...action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseCode]: activeStudentCalendarsByCourse(state[currentCourse.courseCode], action),
          }
        }, {})
      }
    case 'REQUEST_ACTIVE_STUDENT_CALENDARS':
    case 'RECEIVE_ACTIVE_STUDENT_CALENDARS':
      return {
        ...state,
        [action.courseCode]: activeStudentCalendarsByCourse(state[action.courseCode], action),
      }
    default:
      return state
  }
}

export default activeStudentCalendars
